var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.learningUnit)?_c('div',{staticClass:"h5 display-4 mt-1 mb-5 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.learningUnit.name)+" ")]):_vm._e(),_c('BaseFormSection',{attrs:{"learning-unit":_vm.learningUnit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }